import { render, staticRenderFns } from "./TermsOfAcceptancePage.vue?vue&type=template&id=e02fb14e&scoped=true&"
import script from "./TermsOfAcceptancePage.vue?vue&type=script&lang=js&"
export * from "./TermsOfAcceptancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e02fb14e",
  null
  
)

export default component.exports